import React, { useState, useEffect } from 'react';

const API = 'http://localhost:8000/api/v1';

function LawUpdates() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    fetch(API + '/tax/law_updates')
      .then(r => r.json())
      .then(d => setUpdates(d.updates || []));
  }, []);

  return (
    <div>
      <h2>Обновления налогового законодательства</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Автоматический сбор с сайтов ФНС и Консультант.ру
      </p>
      {updates.length === 0 && <p style={{ color: '#94A3B8' }}>Загрузка...</p>}
      {updates.map((u, i) => (
        <div key={i} style={{ padding: 12, marginBottom: 8, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
            <span style={{ fontSize: 12, color: '#6366F1' }}>{u.source}</span>
            <span style={{ fontSize: 11, color: '#94A3B8' }}>{u.date}</span>
          </div>
          <a href={u.url} target="_blank" rel="noopener noreferrer" style={{ color: '#F8FAFC', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
            {u.title}
          </a>
        </div>
      ))}
    </div>
  );
}

export default LawUpdates;